module.exports = true;



//////////////////
// WEBPACK FOOTER
// ../core-js/library/modules/_library.js
// module id = 286
// module chunks = 25